export const countryListPhoneNumberCode=[
	{
		"code": "+7 840",
		"name": "Abkhazia"
	  },
	  {
		"code": "+93",
		"name": "Afghanistan"
	  },
	  {
		"code": "+355",
		"name": "Albania"
	  },
	  {
		"code": "+213",
		"name": "Algeria"
	  },
	  {
		"code": "+1 684",
		"name": "American Samoa"
	  },
	  {
		"code": "+376",
		"name": "Andorra"
	  },
	  {
		"code": "+244",
		"name": "Angola"
	  },
	  {
		"code": "+1 264",
		"name": "Anguilla"
	  },
	  {
		"code": "+1 268",
		"name": "Antigua and Barbuda"
	  },
	  {
		"code": "+54",
		"name": "Argentina"
	  },
	  {
		"code": "+374",
		"name": "Armenia"
	  },
	  {
		"code": "+297",
		"name": "Aruba"
	  },
	  {
		"code": "+247",
		"name": "Ascension"
	  },
	  {
		"code": "+61",
		"name": "Australia"
	  },
	  {
		"code": "+672",
		"name": "Australian External Territories"
	  },
	  {
		"code": "+43",
		"name": "Austria"
	  },
	  {
		"code": "+994",
		"name": "Azerbaijan"
	  },
	  {
		"code": "+1 242",
		"name": "Bahamas"
	  },
	  {
		"code": "+973",
		"name": "Bahrain"
	  },
	  {
		"code": "+880",
		"name": "Bangladesh"
	  },
	  {
		"code": "+1 246",
		"name": "Barbados"
	  },
	  {
		"code": "+1 268",
		"name": "Barbuda"
	  },
	  {
		"code": "+375",
		"name": "Belarus"
	  },
	  {
		"code": "+32",
		"name": "Belgium"
	  },
	  {
		"code": "+501",
		"name": "Belize"
	  },
	  {
		"code": "+229",
		"name": "Benin"
	  },
	  {
		"code": "+1 441",
		"name": "Bermuda"
	  },
	  {
		"code": "+975",
		"name": "Bhutan"
	  },
	  {
		"code": "+591",
		"name": "Bolivia"
	  },
	  {
		"code": "+387",
		"name": "Bosnia and Herzegovina"
	  },
	  {
		"code": "+267",
		"name": "Botswana"
	  },
	  {
		"code": "+55",
		"name": "Brazil"
	  },
	  {
		"code": "+246",
		"name": "British Indian Ocean Territory"
	  },
	  {
		"code": "+1 284",
		"name": "British Virgin Islands"
	  },
	  {
		"code": "+673",
		"name": "Brunei"
	  },
	  {
		"code": "+359",
		"name": "Bulgaria"
	  },
	  {
		"code": "+226",
		"name": "Burkina Faso"
	  },
	  {
		"code": "+257",
		"name": "Burundi"
	  },
	  {
		"code": "+855",
		"name": "Cambodia"
	  },
	  {
		"code": "+237",
		"name": "Cameroon"
	  },
	  {
		"code": "+1",
		"name": "Canada"
	  },
	  {
		"code": "+238",
		"name": "Cape Verde"
	  },
	  {
		"code": "+ 345",
		"name": "Cayman Islands"
	  },
	  {
		"code": "+236",
		"name": "Central African Republic"
	  },
	  {
		"code": "+235",
		"name": "Chad"
	  },
	  {
		"code": "+56",
		"name": "Chile"
	  },
	  {
		"code": "+86",
		"name": "China"
	  },
	  {
		"code": "+61",
		"name": "Christmas Island"
	  },
	  {
		"code": "+61",
		"name": "Cocos-Keeling Islands"
	  },
	  {
		"code": "+57",
		"name": "Colombia"
	  },
	  {
		"code": "+269",
		"name": "Comoros"
	  },
	  {
		"code": "+242",
		"name": "Congo"
	  },
	  {
		"code": "+243",
		"name": "Congo, Dem. Rep. of (Zaire)"
	  },
	  {
		"code": "+682",
		"name": "Cook Islands"
	  },
	  {
		"code": "+506",
		"name": "Costa Rica"
	  },
	  {
		"code": "+385",
		"name": "Croatia"
	  },
	  {
		"code": "+53",
		"name": "Cuba"
	  },
	  {
		"code": "+599",
		"name": "Curacao"
	  },
	  {
		"code": "+537",
		"name": "Cyprus"
	  },
	  {
		"code": "+420",
		"name": "Czech Republic"
	  },
	  {
		"code": "+45",
		"name": "Denmark"
	  },
	  {
		"code": "+246",
		"name": "Diego Garcia"
	  },
	  {
		"code": "+253",
		"name": "Djibouti"
	  },
	  {
		"code": "+1 767",
		"name": "Dominica"
	  },
	  {
		"code": "+1 809",
		"name": "Dominican Republic"
	  },
	  {
		"code": "+670",
		"name": "East Timor"
	  },
	  {
		"code": "+56",
		"name": "Easter Island"
	  },
	  {
		"code": "+593",
		"name": "Ecuador"
	  },
	  {
		"code": "+20",
		"name": "Egypt"
	  },
	  {
		"code": "+503",
		"name": "El Salvador"
	  },
	  {
		"code": "+240",
		"name": "Equatorial Guinea"
	  },
	  {
		"code": "+291",
		"name": "Eritrea"
	  },
	  {
		"code": "+372",
		"name": "Estonia"
	  },
	  {
		"code": "+251",
		"name": "Ethiopia"
	  },
	  {
		"code": "+500",
		"name": "Falkland Islands"
	  },
	  {
		"code": "+298",
		"name": "Faroe Islands"
	  },
	  {
		"code": "+679",
		"name": "Fiji"
	  },
	  {
		"code": "+358",
		"name": "Finland"
	  },
	  {
		"code": "+33",
		"name": "France"
	  },
	  {
		"code": "+596",
		"name": "French Antilles"
	  },
	  {
		"code": "+594",
		"name": "French Guiana"
	  },
	  {
		"code": "+689",
		"name": "French Polynesia"
	  },
	  {
		"code": "+241",
		"name": "Gabon"
	  },
	  {
		"code": "+220",
		"name": "Gambia"
	  },
	  {
		"code": "+995",
		"name": "Georgia"
	  },
	  {
		"code": "+49",
		"name": "Germany"
	  },
	  {
		"code": "+233",
		"name": "Ghana"
	  },
	  {
		"code": "+350",
		"name": "Gibraltar"
	  },
	  {
		"code": "+30",
		"name": "Greece"
	  },
	  {
		"code": "+299",
		"name": "Greenland"
	  },
	  {
		"code": "+1 473",
		"name": "Grenada"
	  },
	  {
		"code": "+590",
		"name": "Guadeloupe"
	  },
	  {
		"code": "+1 671",
		"name": "Guam"
	  },
	  {
		"code": "+502",
		"name": "Guatemala"
	  },
	  {
		"code": "+224",
		"name": "Guinea"
	  },
	  {
		"code": "+245",
		"name": "Guinea-Bissau"
	  },
	  {
		"code": "+595",
		"name": "Guyana"
	  },
	  {
		"code": "+509",
		"name": "Haiti"
	  },
	  {
		"code": "+504",
		"name": "Honduras"
	  },
	  {
		"code": "+852",
		"name": "Hong Kong SAR China"
	  },
	  {
		"code": "+36",
		"name": "Hungary"
	  },
	  {
		"code": "+354",
		"name": "Iceland"
	  },
	  {
		"code": "+91",
		"name": "India"
	  },
	  {
		"code": "+62",
		"name": "Indonesia"
	  },
	  {
		"code": "+98",
		"name": "Iran"
	  },
	  {
		"code": "+964",
		"name": "Iraq"
	  },
	  {
		"code": "+353",
		"name": "Ireland"
	  },
	  {
		"code": "+972",
		"name": "Israel"
	  },
	  {
		"code": "+39",
		"name": "Italy"
	  },
	  {
		"code": "+225",
		"name": "Ivory Coast"
	  },
	  {
		"code": "+1 876",
		"name": "Jamaica"
	  },
	  {
		"code": "+81",
		"name": "Japan"
	  },
	  {
		"code": "+962",
		"name": "Jordan"
	  },
	  {
		"code": "+7 7",
		"name": "Kazakhstan"
	  },
	  {
		"code": "+254",
		"name": "Kenya"
	  },
	  {
		"code": "+686",
		"name": "Kiribati"
	  },
	  {
		"code": "+965",
		"name": "Kuwait"
	  },
	  {
		"code": "+996",
		"name": "Kyrgyzstan"
	  },
	  {
		"code": "+856",
		"name": "Laos"
	  },
	  {
		"code": "+371",
		"name": "Latvia"
	  },
	  {
		"code": "+961",
		"name": "Lebanon"
	  },
	  {
		"code": "+266",
		"name": "Lesotho"
	  },
	  {
		"code": "+231",
		"name": "Liberia"
	  },
	  {
		"code": "+218",
		"name": "Libya"
	  },
	  {
		"code": "+423",
		"name": "Liechtenstein"
	  },
	  {
		"code": "+370",
		"name": "Lithuania"
	  },
	  {
		"code": "+352",
		"name": "Luxembourg"
	  },
	  {
		"code": "+853",
		"name": "Macau SAR China"
	  },
	  {
		"code": "+389",
		"name": "Macedonia"
	  },
	  {
		"code": "+261",
		"name": "Madagascar"
	  },
	  {
		"code": "+265",
		"name": "Malawi"
	  },
	  {
		"code": "+60",
		"name": "Malaysia"
	  },
	  {
		"code": "+960",
		"name": "Maldives"
	  },
	  {
		"code": "+223",
		"name": "Mali"
	  },
	  {
		"code": "+356",
		"name": "Malta"
	  },
	  {
		"code": "+692",
		"name": "Marshall Islands"
	  },
	  {
		"code": "+596",
		"name": "Martinique"
	  },
	  {
		"code": "+222",
		"name": "Mauritania"
	  },
	  {
		"code": "+230",
		"name": "Mauritius"
	  },
	  {
		"code": "+262",
		"name": "Mayotte"
	  },
	  {
		"code": "+52",
		"name": "Mexico"
	  },
	  {
		"code": "+691",
		"name": "Micronesia"
	  },
	  {
		"code": "+1 808",
		"name": "Midway Island"
	  },
	  {
		"code": "+373",
		"name": "Moldova"
	  },
	  {
		"code": "+377",
		"name": "Monaco"
	  },
	  {
		"code": "+976",
		"name": "Mongolia"
	  },
	  {
		"code": "+382",
		"name": "Montenegro"
	  },
	  {
		"code": "+1664",
		"name": "Montserrat"
	  },
	  {
		"code": "+212",
		"name": "Morocco"
	  },
	  {
		"code": "+95",
		"name": "Myanmar"
	  },
	  {
		"code": "+264",
		"name": "Namibia"
	  },
	  {
		"code": "+674",
		"name": "Nauru"
	  },
	  {
		"code": "+977",
		"name": "Nepal"
	  },
	  {
		"code": "+31",
		"name": "Netherlands"
	  },
	  {
		"code": "+599",
		"name": "Netherlands Antilles"
	  },
	  {
		"code": "+1 869",
		"name": "Nevis"
	  },
	  {
		"code": "+687",
		"name": "New Caledonia"
	  },
	  {
		"code": "+64",
		"name": "New Zealand"
	  },
	  {
		"code": "+505",
		"name": "Nicaragua"
	  },
	  {
		"code": "+227",
		"name": "Niger"
	  },
	  {
		"code": "+234",
		"name": "Nigeria"
	  },
	  {
		"code": "+683",
		"name": "Niue"
	  },
	  {
		"code": "+672",
		"name": "Norfolk Island"
	  },
	  {
		"code": "+850",
		"name": "North Korea"
	  },
	  {
		"code": "+1 670",
		"name": "Northern Mariana Islands"
	  },
	  {
		"code": "+47",
		"name": "Norway"
	  },
	  {
		"code": "+968",
		"name": "Oman"
	  },
	  {
		"code": "+92",
		"name": "Pakistan"
	  },
	  {
		"code": "+680",
		"name": "Palau"
	  },
	  {
		"code": "+970",
		"name": "Palestinian Territory"
	  },
	  {
		"code": "+507",
		"name": "Panama"
	  },
	  {
		"code": "+675",
		"name": "Papua New Guinea"
	  },
	  {
		"code": "+595",
		"name": "Paraguay"
	  },
	  {
		"code": "+51",
		"name": "Peru"
	  },
	  {
		"code": "+63",
		"name": "Philippines"
	  },
	  {
		"code": "+48",
		"name": "Poland"
	  },
	  {
		"code": "+351",
		"name": "Portugal"
	  },
	  {
		"code": "+1 787",
		"name": "Puerto Rico"
	  },
	  {
		"code": "+974",
		"name": "Qatar"
	  },
	  {
		"code": "+262",
		"name": "Reunion"
	  },
	  {
		"code": "+40",
		"name": "Romania"
	  },
	  {
		"code": "+7",
		"name": "Russia"
	  },
	  {
		"code": "+250",
		"name": "Rwanda"
	  },
	  {
		"code": "+685",
		"name": "Samoa"
	  },
	  {
		"code": "+378",
		"name": "San Marino"
	  },
	  {
		"code": "+966",
		"name": "Saudi Arabia"
	  },
	  {
		"code": "+221",
		"name": "Senegal"
	  },
	  {
		"code": "+381",
		"name": "Serbia"
	  },
	  {
		"code": "+248",
		"name": "Seychelles"
	  },
	  {
		"code": "+232",
		"name": "Sierra Leone"
	  },
	  {
		"code": "+65",
		"name": "Singapore"
	  },
	  {
		"code": "+421",
		"name": "Slovakia"
	  },
	  {
		"code": "+386",
		"name": "Slovenia"
	  },
	  {
		"code": "+677",
		"name": "Solomon Islands"
	  },
	  {
		"code": "+27",
		"name": "South Africa"
	  },
	  {
		"code": "+500",
		"name": "South Georgia and the South Sandwich Islands"
	  },
	  {
		"code": "+82",
		"name": "South Korea"
	  },
	  {
		"code": "+34",
		"name": "Spain"
	  },
	  {
		"code": "+94",
		"name": "Sri Lanka"
	  },
	  {
		"code": "+249",
		"name": "Sudan"
	  },
	  {
		"code": "+597",
		"name": "Suriname"
	  },
	  {
		"code": "+268",
		"name": "Swaziland"
	  },
	  {
		"code": "+46",
		"name": "Sweden"
	  },
	  {
		"code": "+41",
		"name": "Switzerland"
	  },
	  {
		"code": "+963",
		"name": "Syria"
	  },
	  {
		"code": "+886",
		"name": "Taiwan"
	  },
	  {
		"code": "+992",
		"name": "Tajikistan"
	  },
	  {
		"code": "+255",
		"name": "Tanzania"
	  },
	  {
		"code": "+66",
		"name": "Thailand"
	  },
	  {
		"code": "+670",
		"name": "Timor Leste"
	  },
	  {
		"code": "+228",
		"name": "Togo"
	  },
	  {
		"code": "+690",
		"name": "Tokelau"
	  },
	  {
		"code": "+676",
		"name": "Tonga"
	  },
	  {
		"code": "+1 868",
		"name": "Trinidad and Tobago"
	  },
	  {
		"code": "+216",
		"name": "Tunisia"
	  },
	  {
		"code": "+90",
		"name": "Turkey"
	  },
	  {
		"code": "+993",
		"name": "Turkmenistan"
	  },
	  {
		"code": "+1 649",
		"name": "Turks and Caicos Islands"
	  },
	  {
		"code": "+688",
		"name": "Tuvalu"
	  },
	  {
		"code": "+1 340",
		"name": "U.S. Virgin Islands"
	  },
	  {
		"code": "+256",
		"name": "Uganda"
	  },
	  {
		"code": "+380",
		"name": "Ukraine"
	  },
	  {
		"code": "+971",
		"name": "United Arab Emirates"
	  },
	  {
		"code": "+44",
		"name": "United Kingdom"
	  },
	  {
		"code": "+1",
		"name": "United States"
	  },
	  {
		"code": "+598",
		"name": "Uruguay"
	  },
	  {
		"code": "+998",
		"name": "Uzbekistan"
	  },
	  {
		"code": "+678",
		"name": "Vanuatu"
	  },
	  {
		"code": "+58",
		"name": "Venezuela"
	  },
	  {
		"code": "+84",
		"name": "Vietnam"
	  },
	  {
		"code": "+1 808",
		"name": "Wake Island"
	  },
	  {
		"code": "+681",
		"name": "Wallis and Futuna"
	  },
	  {
		"code": "+967",
		"name": "Yemen"
	  },
	  {
		"code": "+260",
		"name": "Zambia"
	  },
	  {
		"code": "+255",
		"name": "Zanzibar"
	  },
	  {
		"code": "+263",
		"name": "Zimbabwe"
	  }
]

export const countryList = [
	"Afghanistan",
	"Albania",
	"Algeria",
	"American Samoa",
	"Andorra",
	"Angola",
	"Anguilla",
	"Antarctica",
	"Antigua and Barbuda",
	"Argentina",
	"Armenia",
	"Aruba",
	"Australia",
	"Austria",
	"Azerbaijan",
	"Bahamas (the)",
	"Bahrain",
	"Bangladesh",
	"Barbados",
	"Belarus",
	"Belgium",
	"Belize",
	"Benin",
	"Bermuda",
	"Bhutan",
	"Bolivia (Plurinational State of)",
	"Bonaire, Sint Eustatius and Saba",
	"Bosnia and Herzegovina",
	"Botswana",
	"Bouvet Island",
	"Brazil",
	"British Indian Ocean Territory (the)",
	"Brunei Darussalam",
	"Bulgaria",
	"Burkina Faso",
	"Burundi",
	"Cabo Verde",
	"Cambodia",
	"Cameroon",
	"Canada",
	"Cayman Islands (the)",
	"Central African Republic (the)",
	"Chad",
	"Chile",
	"China",
	"Christmas Island",
	"Cocos (Keeling) Islands (the)",
	"Colombia",
	"Comoros (the)",
	"Congo (the Democratic Republic of the)",
	"Congo (the)",
	"Cook Islands (the)",
	"Costa Rica",
	"Croatia",
	"Cuba",
	"Curaçao",
	"Cyprus",
	"Czechia",
	"Côte d'Ivoire",
	"Denmark",
	"Djibouti",
	"Dominica",
	"Dominican Republic (the)",
	"Ecuador",
	"Egypt",
	"El Salvador",
	"Equatorial Guinea",
	"Eritrea",
	"Estonia",
	"Eswatini",
	"Ethiopia",
	"Falkland Islands (the) [Malvinas]",
	"Faroe Islands (the)",
	"Fiji",
	"Finland",
	"France",
	"French Guiana",
	"French Polynesia",
	"French Southern Territories (the)",
	"Gabon",
	"Gambia (the)",
	"Georgia",
	"Germany",
	"Ghana",
	"Gibraltar",
	"Greece",
	"Greenland",
	"Grenada",
	"Guadeloupe",
	"Guam",
	"Guatemala",
	"Guernsey",
	"Guinea",
	"Guinea-Bissau",
	"Guyana",
	"Haiti",
	"Heard Island and McDonald Islands",
	"Holy See (the)",
	"Honduras",
	"Hong Kong",
	"Hungary",
	"Iceland",
	"India",
	"Indonesia",
	"Iran (Islamic Republic of)",
	"Iraq",
	"Ireland",
	"Isle of Man",
	"Israel",
	"Italy",
	"Jamaica",
	"Japan",
	"Jersey",
	"Jordan",
	"Kazakhstan",
	"Kenya",
	"Kiribati",
	"Korea (the Democratic People's Republic of)",
	"Korea (the Republic of)",
	"Kuwait",
	"Kyrgyzstan",
	"Lao People's Democratic Republic (the)",
	"Latvia",
	"Lebanon",
	"Lesotho",
	"Liberia",
	"Libya",
	"Liechtenstein",
	"Lithuania",
	"Luxembourg",
	"Macao",
	"Madagascar",
	"Malawi",
	"Malaysia",
	"Maldives",
	"Mali",
	"Malta",
	"Marshall Islands (the)",
	"Martinique",
	"Mauritania",
	"Mauritius",
	"Mayotte",
	"Mexico",
	"Micronesia (Federated States of)",
	"Moldova (the Republic of)",
	"Monaco",
	"Mongolia",
	"Montenegro",
	"Montserrat",
	"Morocco",
	"Mozambique",
	"Myanmar",
	"Namibia",
	"Nauru",
	"Nepal",
	"Netherlands (the)",
	"New Caledonia",
	"New Zealand",
	"Nicaragua",
	"Niger (the)",
	"Nigeria",
	"Niue",
	"Norfolk Island",
	"Northern Mariana Islands (the)",
	"Norway",
	"Oman",
	"Pakistan",
	"Palau",
	"Palestine, State of",
	"Panama",
	"Papua New Guinea",
	"Paraguay",
	"Peru",
	"Philippines (the)",
	"Pitcairn",
	"Poland",
	"Portugal",
	"Puerto Rico",
	"Qatar",
	"Republic of North Macedonia",
	"Romania",
	"Russian Federation (the)",
	"Rwanda",
	"Réunion",
	"Saint Barthélemy",
	"Saint Helena, Ascension and Tristan da Cunha",
	"Saint Kitts and Nevis",
	"Saint Lucia",
	"Saint Martin (French part)",
	"Saint Pierre and Miquelon",
	"Saint Vincent and the Grenadines",
	"Samoa",
	"San Marino",
	"Sao Tome and Principe",
	"Saudi Arabia",
	"Senegal",
	"Serbia",
	"Seychelles",
	"Sierra Leone",
	"Singapore",
	"Sint Maarten (Dutch part)",
	"Slovakia",
	"Slovenia",
	"Solomon Islands",
	"Somalia",
	"South Africa",
	"South Georgia and the South Sandwich Islands",
	"South Sudan",
	"Spain",
	"Sri Lanka",
	"Sudan (the)",
	"Suriname",
	"Svalbard and Jan Mayen",
	"Sweden",
	"Switzerland",
	"Syrian Arab Republic",
	"Taiwan",
	"Tajikistan",
	"Tanzania, United Republic of",
	"Thailand",
	"Timor-Leste",
	"Togo",
	"Tokelau",
	"Tonga",
	"Trinidad and Tobago",
	"Tunisia",
	"Turkey",
	"Turkmenistan",
	"Turks and Caicos Islands (the)",
	"Tuvalu",
	"Uganda",
	"Ukraine",
	"United Arab Emirates (the)",
	"United Kingdom of Great Britain and Northern Ireland (the)",
	"United States Minor Outlying Islands (the)",
	"United States of America (the)",
	"Uruguay",
	"Uzbekistan",
	"Vanuatu",
	"Venezuela (Bolivarian Republic of)",
	"Viet Nam",
	"Virgin Islands (British)",
	"Virgin Islands (U.S.)",
	"Wallis and Futuna",
	"Western Sahara",
	"Yemen",
	"Zambia",
	"Zimbabwe",
	"Åland Islands"
];

export const biddersStatus = [
	"Active",
	"Inactive",
	"Close",
]

export const companyList = [
	"Wester",
	"Infosys",
	"Kotak",
	"Wipro",
	"Asian",
	"Larsen",
	"Titan",
	"Cadila"
]

export const teamList = [
	"Front-end",
	"Back-end",
	"Marketing",
	"Design",
	"HR"
]

export const managerList = [
	"Robert",
	"Alexander",
	"Andrew",
	"Agastya",
	"Archer",
	"Anand",
	"Noah",
	"Anthony",
	"Oliver"

]

export const managedByList = [
	"Admin",
	"User",
];

export const projectAreaList = [
	"India",
];

export const projectStageList = [
	'Evaluation',
	'Finalizing',
	'Cancelled',
	'Awarded'
];

export const stautsList = [
	"Active",
	"Close",
	"Inactive"
];

export const constValue = {
	logo: 'Upload your Logo',
	footerCompanyName: 'DBiz Labs © 2024',
	footerProjectName: 'Tender.ai',
	status: "Status",
	tasks: 'TASKS',
	new: 'New',
	templates: 'Templates',
	createProject: 'Create New Projects',
	addTemplate: 'Add Templates',
	template: "Templete",
	submssions: "SUBMISSIONS",
	project: 'PROJECT',
	agency: "Agencies",
	addagency: 'Agency',
	all: "All",
	sno: "S.No",
	projectName: "Project Name",
	projectCode: 'Project Code',
	description: "Description",
	tags: "Tags",
	projectStage: 'Project Stage',
	profile:'Profile',
	full_name:'Full Name',
	name:'Name',
	phone_no:'Phone Number',
	company:'Company',
	manager:'Manager',
	team:'Team',
	role:'Role',
	emp_count:'Employee Count',
	domain:'Domain',
	team_manager:'Team Manager',
	logo_name:'Logo',
	email:'Email',
	value:'Value',
	creation:'Creation',
	created_by:'Created By',
	action:'Action',
	templateName:"Template Name",
	tenant:"Tenant",
	organisation:"Organisation",
	moduleversion:"Module/Version",
	requestedOn:"Requested On",
	types:"Types",
	comments:"Commments",



};


export const font = {
	fontFamily: 'Roboto',
	poppins: 'Poppins, sans-serif',
	fontStyleBold: 'bold',
	fontStyleNormal: 'normal',
	fontWeightfive: '500',
	fontWeightsix: '600',
	fontWeightfour: '400',
	fontWeightThree: '300',
	fontWeightSeven: '700',
	fontWeightEight: '800',
	ten: '10px',
	twelve: '12px',
	thirteen: '13px',
	sixteen: '16px',
	eighteen: '18px',
	fourteen: '14px',
	twentyfour: '24px',
	twenty: '20px'

};


export const project = {
	projectName: "Project Name",
	projectCode: "Project Code",
	description: "Description",
	tags: "Tags",
	finalization: "Finalization date ",
	projectArea: "Project Type",
	projectAreas: "Project Area",
	managedBy: "Managed By",
	status: "Status",
	projectStage: "Project Stage",
	addProject: "Add Project Details",
	createProject: "Create Project",
	next: "Next",
	back: "Back",
	submit: "Submit",
	addBidder: "Add Bidder",
	selectetemplate: 'Select Template',
	update: 'Update'

};
export const defaultBidders='data:image/png;base64,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'
export const defaultTeams='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJUZW5hbnQiPgo8Y2lyY2xlIGlkPSJFbGxpcHNlIDM1MCIgY3g9IjY0IiBjeT0iNjQiIHI9IjYyLjUiIGZpbGw9IiNERkU1RjEiIHN0cm9rZT0iIzhFOThBNyIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGlkPSJWZWN0b3IiIG9wYWNpdHk9IjAuMyIgZD0iTTY0IDU4QzY3Ljg2NiA1OCA3MSA1NC44NjYgNzEgNTFDNzEgNDcuMTM0IDY3Ljg2NiA0NCA2NCA0NEM2MC4xMzQgNDQgNTcgNDcuMTM0IDU3IDUxQzU3IDU0Ljg2NiA2MC4xMzQgNTggNjQgNThaIiBmaWxsPSIjOEU5OEE3Ii8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgb3BhY2l0eT0iMC4zIiBkPSJNNjQuNSA3M0M1NS43MjUgNzMgNDUuNjUgNzcuMyA0NSA3OS43VjgzSDg0Vjc5LjY2NjdDODMuMzUgNzcuMyA3My4yNzUgNzMgNjQuNSA3M1oiIGZpbGw9IiM4RTk4QTciLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNNjQgNjRDNzAuOTA2MiA2NCA3Ni41IDU4LjQwNjIgNzYuNSA1MS41Qzc2LjUgNDQuNTkzOCA3MC45MDYyIDM5IDY0IDM5QzU3LjA5MzggMzkgNTEuNSA0NC41OTM4IDUxLjUgNTEuNUM1MS41IDU4LjQwNjIgNTcuMDkzOCA2NCA2NCA2NFpNNjQgNDUuMjVDNjcuNDM3NSA0NS4yNSA3MC4yNSA0OC4wNjI1IDcwLjI1IDUxLjVDNzAuMjUgNTQuOTM3NSA2Ny40Mzc1IDU3Ljc1IDY0IDU3Ljc1QzYwLjU2MjUgNTcuNzUgNTcuNzUgNTQuOTM3NSA1Ny43NSA1MS41QzU3Ljc1IDQ4LjA2MjUgNjAuNTYyNSA0NS4yNSA2NCA0NS4yNVpNNjQgNjcuMTI1QzU1LjY1NjIgNjcuMTI1IDM5IDcxLjMxMjUgMzkgNzkuNjI1Vjg5SDg5Vjc5LjYyNUM4OSA3MS4zMTI1IDcyLjM0MzggNjcuMTI1IDY0IDY3LjEyNVpNODIuNzUgODIuNzVINDUuMjVWNzkuNjU2MkM0NS44NzUgNzcuNDA2MiA1NS41NjI1IDczLjM3NSA2NCA3My4zNzVDNzIuNDM3NSA3My4zNzUgODIuMTI1IDc3LjQwNjIgODIuNzUgNzkuNjI1VjgyLjc1WiIgZmlsbD0iIzhFOThBNyIvPgo8L2c+Cjwvc3ZnPgo=';
export const defaultRole ='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJUZW5hbnQiPgo8Y2lyY2xlIGlkPSJFbGxpcHNlIDM1MCIgY3g9IjY0IiBjeT0iNjQiIHI9IjYyLjUiIGZpbGw9IiNERkU1RjEiIHN0cm9rZT0iIzhFOThBNyIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGlkPSJWZWN0b3IiIG9wYWNpdHk9IjAuMyIgZD0iTTY0IDU4QzY3Ljg2NiA1OCA3MSA1NC44NjYgNzEgNTFDNzEgNDcuMTM0IDY3Ljg2NiA0NCA2NCA0NEM2MC4xMzQgNDQgNTcgNDcuMTM0IDU3IDUxQzU3IDU0Ljg2NiA2MC4xMzQgNTggNjQgNThaIiBmaWxsPSIjOEU5OEE3Ii8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgb3BhY2l0eT0iMC4zIiBkPSJNNjQuNSA3M0M1NS43MjUgNzMgNDUuNjUgNzcuMyA0NSA3OS43VjgzSDg0Vjc5LjY2NjdDODMuMzUgNzcuMyA3My4yNzUgNzMgNjQuNSA3M1oiIGZpbGw9IiM4RTk4QTciLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNNjQgNjRDNzAuOTA2MiA2NCA3Ni41IDU4LjQwNjIgNzYuNSA1MS41Qzc2LjUgNDQuNTkzOCA3MC45MDYyIDM5IDY0IDM5QzU3LjA5MzggMzkgNTEuNSA0NC41OTM4IDUxLjUgNTEuNUM1MS41IDU4LjQwNjIgNTcuMDkzOCA2NCA2NCA2NFpNNjQgNDUuMjVDNjcuNDM3NSA0NS4yNSA3MC4yNSA0OC4wNjI1IDcwLjI1IDUxLjVDNzAuMjUgNTQuOTM3NSA2Ny40Mzc1IDU3Ljc1IDY0IDU3Ljc1QzYwLjU2MjUgNTcuNzUgNTcuNzUgNTQuOTM3NSA1Ny43NSA1MS41QzU3Ljc1IDQ4LjA2MjUgNjAuNTYyNSA0NS4yNSA2NCA0NS4yNVpNNjQgNjcuMTI1QzU1LjY1NjIgNjcuMTI1IDM5IDcxLjMxMjUgMzkgNzkuNjI1Vjg5SDg5Vjc5LjYyNUM4OSA3MS4zMTI1IDcyLjM0MzggNjcuMTI1IDY0IDY3LjEyNVpNODIuNzUgODIuNzVINDUuMjVWNzkuNjU2MkM0NS44NzUgNzcuNDA2MiA1NS41NjI1IDczLjM3NSA2NCA3My4zNzVDNzIuNDM3NSA3My4zNzUgODIuMTI1IDc3LjQwNjIgODIuNzUgNzkuNjI1VjgyLjc1WiIgZmlsbD0iIzhFOThBNyIvPgo8L2c+Cjwvc3ZnPgo=';
export const defaultUserImage='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJUZW5hbnQiPgo8Y2lyY2xlIGlkPSJFbGxpcHNlIDM1MCIgY3g9IjY0IiBjeT0iNjQiIHI9IjYyLjUiIGZpbGw9IiNERkU1RjEiIHN0cm9rZT0iIzhFOThBNyIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGlkPSJWZWN0b3IiIG9wYWNpdHk9IjAuMyIgZD0iTTY0IDU4QzY3Ljg2NiA1OCA3MSA1NC44NjYgNzEgNTFDNzEgNDcuMTM0IDY3Ljg2NiA0NCA2NCA0NEM2MC4xMzQgNDQgNTcgNDcuMTM0IDU3IDUxQzU3IDU0Ljg2NiA2MC4xMzQgNTggNjQgNThaIiBmaWxsPSIjOEU5OEE3Ii8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgb3BhY2l0eT0iMC4zIiBkPSJNNjQuNSA3M0M1NS43MjUgNzMgNDUuNjUgNzcuMyA0NSA3OS43VjgzSDg0Vjc5LjY2NjdDODMuMzUgNzcuMyA3My4yNzUgNzMgNjQuNSA3M1oiIGZpbGw9IiM4RTk4QTciLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNNjQgNjRDNzAuOTA2MiA2NCA3Ni41IDU4LjQwNjIgNzYuNSA1MS41Qzc2LjUgNDQuNTkzOCA3MC45MDYyIDM5IDY0IDM5QzU3LjA5MzggMzkgNTEuNSA0NC41OTM4IDUxLjUgNTEuNUM1MS41IDU4LjQwNjIgNTcuMDkzOCA2NCA2NCA2NFpNNjQgNDUuMjVDNjcuNDM3NSA0NS4yNSA3MC4yNSA0OC4wNjI1IDcwLjI1IDUxLjVDNzAuMjUgNTQuOTM3NSA2Ny40Mzc1IDU3Ljc1IDY0IDU3Ljc1QzYwLjU2MjUgNTcuNzUgNTcuNzUgNTQuOTM3NSA1Ny43NSA1MS41QzU3Ljc1IDQ4LjA2MjUgNjAuNTYyNSA0NS4yNSA2NCA0NS4yNVpNNjQgNjcuMTI1QzU1LjY1NjIgNjcuMTI1IDM5IDcxLjMxMjUgMzkgNzkuNjI1Vjg5SDg5Vjc5LjYyNUM4OSA3MS4zMTI1IDcyLjM0MzggNjcuMTI1IDY0IDY3LjEyNVpNODIuNzUgODIuNzVINDUuMjVWNzkuNjU2MkM0NS44NzUgNzcuNDA2MiA1NS41NjI1IDczLjM3NSA2NCA3My4zNzVDNzIuNDM3NSA3My4zNzUgODIuMTI1IDc3LjQwNjIgODIuNzUgNzkuNjI1VjgyLjc1WiIgZmlsbD0iIzhFOThBNyIvPgo8L2c+Cjwvc3ZnPgo=';
export const defaultTeamImage ='data:image/png;base64,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'
export const defaultParentImage = 'data:image/png;base64,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'
export const defaultChildImage = 'data:image/png;base64,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'
export const bidderDefaultImage = 'data:image/png;base64,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'